import script from "./EventsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsPage.vue?vue&type=script&setup=true&lang=js"

import "./EventsPage.vue?vue&type=style&index=0&id=3d5276b2&lang=css"
import "./EventsPage.vue?vue&type=style&index=1&id=3d5276b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d5276b2"]])

export default __exports__